module.exports = {
  citiesData: () => {
    return{
      "Armenia": "Armenia",
      "Barranquilla": "Barranquilla",
      "Bogotá D.C.": "Bogotá D.C.",
      "Bucaramanga": "Bucaramanga",
      "Cali": "Cali",
      "Cartagena de Indias": "Cartagena de Indias",
      "Cúcuta": "Cúcuta",
      "Ibagué": "Ibagué",
      "Itagüi": "Itagüi",
      "Manizales": "Manizales",
      "Medellín": "Medellín",
      "Montería": "Montería",
      "Neiva": "Neiva",
      "Palmira": "Palmira",
      "Pasto": "Pasto",
      "Pereira": "Pereira",
      "Rionegro": "Rionegro",
      "Santa Marta": "Santa Marta",
      "Tuluá": "Tuluá",
      "Valledupar": "Valledupar",
      "Villavicencio": "Villavicencio",
    }
  }
}